import { Component } from "@angular/core";
import { clientConfig } from "../../../constant/app.constant";
import { Store, select } from "@ngrx/store";
import { CopyHelpers } from "../../../helpers/copy.helpers";
import { NavButton } from "../../navigation/next-button.component";
import { Router } from "@angular/router";
import { AppFlowService } from "../../../services/app-flow/app-flow.service";
import { ReturnOrderService } from "../../../services/return-order/return-order.service";

@Component({
  selector: "app-global-error",
  templateUrl: "./global-error.component.html"
})
export class GlobalErrorComponent {
  icon = "fa-exclamation-triangle";
  error = {
    title: "returnProcessFailedSubject",
    message: "returnProcessFailedBody",
    customerSupport: "returnProcessFailedCustomerSupport",
    translationParams: {
      orderNumber: "",
      customerSupportInput: clientConfig.CUSTOMER_SUPPORT_INPUT
    },
  };
  errorMessage: string | null = null;
  returnOrder: any;
  retryButton: NavButton = {
    buttonText: "retryReturnButton",
    cssClass: "next-btn",
    isDisable: this.returnOrderService.noOfRetries > 3
  };
  goBackButton: NavButton = {
    buttonText: "goBackButton",
    cssClass: "next-btn",
    isDisable: this.returnOrderService.noOfGoBacksAfterReturnFailure > 3
  };

  constructor(private appFlowService: AppFlowService,
    private store: Store<AppState>, private router: Router,
    private returnOrderService: ReturnOrderService) {
    const screenSize = window.innerWidth;
    const route = this.appFlowService.findRouteFromSequence("labelprint");

    if (screenSize > 768) {
      this.retryButton.routeUrl = `/d/labelprint`;
      this.goBackButton.routeUrl = `/d/${route.back}`;
    }
    else {
      this.retryButton.routeUrl = `/m/labelprint`;
      this.goBackButton.routeUrl = `/m/${route.back}`;
    }

    this.store.pipe(select("returnOrder")).subscribe((items) => {
      this.returnOrder = CopyHelpers.deepCopy(items);
      this.error.translationParams.orderNumber = this.returnOrder.orderNumber;
    });

    if (clientConfig.TENANTNAME.toLocaleLowerCase().trim() === "pandora") {
      this.errorMessage = localStorage.getItem('errorMessage') || null;
      console.log(this.errorMessage);
      if (this.errorMessage && ((this.errorMessage.toLowerCase().includes('shipment') || this.errorMessage.toLowerCase().includes('parcel'))
       && this.errorMessage.toLowerCase().includes('exists'))) {
        this.error.message = "duplicateRequestMessage"
        this.error.title = "duplicateRequestTitle"
      }
    }
  }

  onGoBackClicked(event: any) {
    this.returnOrderService.returnOrderLable.show = false;
    this.returnOrderService.noOfGoBacksAfterReturnFailure++;
    this.retryButton.isDisable = this.returnOrderService.noOfGoBacksAfterReturnFailure > 3;
  }

  onRetryClicked(event: any) {
    this.returnOrderService.noOfRetries++;
    this.retryButton.isDisable = this.returnOrderService.noOfRetries > 3;
  }

  ngOnDestroy() {
    localStorage.removeItem('errorMessage');
  }
}
